// Field-component option helpers. Shared by the Data folder and
// the top-bar field picker so both render the same labels/defaults.

import type { FieldMetadata } from '@physics/types';

type Meta = FieldMetadata | Partial<FieldMetadata> | null | undefined;

export function buildFieldComponentOptionsFromMetadata(meta: Meta): Record<string, string> {
    const options: Record<string, string> = {};
    const comps = meta && Array.isArray(meta.field_components) ? meta.field_components : null;
    if (comps && comps.length > 0) {
        const hasBx = comps.includes('Bx');
        const hasBy = comps.includes('By');
        const hasBz = comps.includes('Bz');
        if (hasBx && hasBy && hasBz) options['B Magnitude'] = 'magnitude';
        comps.forEach((c) => { options[c] = c; });
    } else {
        options['Magnitude'] = 'magnitude';
    }
    return options;
}

export function determineDefaultFieldComponent(meta: Meta): string {
    const comps = meta && Array.isArray(meta.field_components) ? meta.field_components : [];
    if (comps.includes('Bx') && comps.includes('By') && comps.includes('Bz')) return 'magnitude';
    return comps[0] || 'magnitude';
}
